import { getLocation } from 'hooks/useHistory'

export const showReactQueryDevTools = () => {
  const disabledByURL = /disable_dev_tools/.test(getLocation().search)
  const disabledByEnv = process.env.REACT_APP_DISABLE_REACT_QUERY_DEV_TOOLS === 'true'
  return !(disabledByURL || disabledByEnv)
}
